import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ConversationMessage } from '../types';

export function useSessionStorage() {
  const [userId, setUserId] = useState<string>('');
  const [conversation, setConversation] = useState<ConversationMessage[]>([]);

  // Get userId from sessionStorage or generate a new one
  function getOrCreateUserId() {
    const storedUserId = sessionStorage.getItem('ai-data-maintenance-user-id');

    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      const newUserId = uuidv4();
      sessionStorage.setItem('ai-data-maintenance-user-id', newUserId);
      setUserId(newUserId);
    }
  }

  // Get conversation from sessionStorage
  function getConversation() {
    const storedConversation = sessionStorage.getItem('ai-data-maintenance-conversation');
    if (storedConversation) {
      try {
        const parsedConversation = JSON.parse(storedConversation);
        // Convert timestamps back to Date objects
        const conversationWithDates = parsedConversation.map((msg: any) => ({
          ...msg,
          timestamp: new Date(msg.timestamp)
        }));
        setConversation(conversationWithDates);
      } catch (e) {
        console.error('Error restoring conversation:', e);
        // Reset conversation if there's an error
        sessionStorage.removeItem('ai-data-maintenance-conversation');
      }
    }
  }

  // Clear conversation and generate new userId
  function clearConversation() {
    setConversation([]);
    sessionStorage.removeItem('ai-data-maintenance-conversation');
    const newUserId = uuidv4();
    setUserId(newUserId);
    sessionStorage.setItem('ai-data-maintenance-user-id', newUserId);
  }

  // Initialize userId and conversation
  useEffect(() => {
    getOrCreateUserId();
    getConversation();
  }, []);

  // Save conversation to sessionStorage when it changes
  useEffect(() => {
    if (conversation.length > 0) {
      sessionStorage.setItem('ai-data-maintenance-conversation', JSON.stringify(conversation));
    }
  }, [conversation]);

  return {
    userId,
    conversation,
    setConversation,
    clearConversation
  };
}
